import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { EntryBadBeatJackpotContainer } from './entryBadBeatJackpotContainer';
import { EntryRecentTourneyWinnersContainer } from './entryRecentTourneyWinnersContainer';
import { NewsPanel } from './news/newsPanel';
const DYNAMIC_COLUMN_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 400px;
`;
const DYNAMIC_COLUMN_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
/**
 * The column of content on the main "entry" scene that consists of real-time, or dynamically-generated content.
 */
export const DynamicEntryColumnContent = () => {
    return (_jsx("div", { css: DYNAMIC_COLUMN_CONTAINER_CSS, children: _jsxs("div", { css: DYNAMIC_COLUMN_CSS, children: [_jsx(EntryBadBeatJackpotContainer, {}), _jsx(EntryRecentTourneyWinnersContainer, {}), _jsx(NewsPanel, {})] }) }));
};
